import { Container } from '@mui/material'
import Navbar from './components/Navbar/Navbar'
import Home from './components/Home/Home'
import Auth from './components/Auth/Auth'
import PostDetails from './components/PostDetails/PostDetails'
import NotFound from './components/NotFound/NotFound'
import {BrowserRouter,Route,Routes,Navigate} from 'react-router-dom';

//the Front-end routing using react-router-dom
function App() {   
    return (   
    <BrowserRouter>
    <Container maxWidth='xl'>        
        <Navbar /> 
         <Routes>                       
         <Route path='/posts' element={<Home />} /> 
         {/* <Route path='/' element={<Home />} /> */}
         <Route path='/' element={<Navigate replace to="/posts" />} />          
         <Route path='/posts/search' element={<Home />} />
         <Route path='/posts/:id' element={<PostDetails />} />
         <Route path='/auth' element={<Auth />}  /> 
         <Route path='*' element={<NotFound />} />                         
        </Routes>  
    </Container>
    </BrowserRouter>
  );
}

export default App;
